import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, LockIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroTestimonials } from '../data/testimonials';
import { HERO_IMAGE, HERO_IMAGE_ALT } from '../data/media';
const features = ['12 Volumes', '6 Bonuses', '150+ Drills', 'All Levels', 'Instant Access'];
const stats = [{
  value: '+500',
  label: 'COACHES'
}, {
  value: '12+6',
  label: 'VOLUMES + BONUSES'
}, {
  value: '4.9/5',
  label: 'RATING ⭐'
}];
export function Hero() {
  return <header className="w-full bg-court-950 text-white" data-id="element-103" data-mp="xbpc32nfnudg">
      <div className="mx-auto flex min-h-[100svh] max-w-6xl flex-col px-5 pb-6 pt-4 sm:px-8 lg:min-h-0 lg:pb-14 lg:pt-10" data-id="element-104" data-mp="sbb57nxkiqh0">
        <div className="flex flex-col items-center gap-1 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-105" data-mp="nczr3108ptsz">
          <span className="font-display text-xs font-extrabold tracking-tight text-ball sm:text-sm" data-id="element-106" data-mp="3d2bjxpolizvj">
            🎾 TENNIS 360™ · CLASS ROOM
          </span>
          <span className="text-[9px] font-semibold uppercase tracking-[0.14em] text-court-600 sm:text-[11px] sm:tracking-[0.16em]" data-id="element-107" data-mp="3j8sdfvbir9n7">
            🎾 Trusted by hundreds of coaches worldwide
          </span>
        </div>

        <div className="flex flex-1 flex-col lg:mt-12 lg:grid lg:flex-none lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-12" data-id="element-108" data-mp="39b4hj226fw3g">
          <div className="flex flex-1 flex-col lg:flex-none" data-id="element-109" data-mp="3e7uvnjuf8hm8">
            <h1 className="mt-4 text-center font-display text-[26px] font-black leading-[1.05] tracking-tight sm:text-4xl lg:mt-0 lg:text-left lg:text-6xl" data-id="element-110" data-mp="30hhovkt9n8yh">
              Plan Your Entire Tennis Year{' '}
              <span className="text-ball" data-id="element-111" data-mp="2qkmthasahoof">In Under 5 Minutes.</span>
            </h1>

            <div className="flex min-h-0 flex-1 items-center justify-center py-3 lg:hidden" data-id="element-112" data-mp="2viev4wiqkp5t">
              <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} width={928} height={1160} decoding="async" fetchPriority="high" className="max-h-[38svh] w-auto max-w-[86%] object-contain" data-id="element-113" data-mp="2hjf7ns6ymgb8" />
            </div>

            <p className="text-center text-[13px] leading-relaxed text-court-600 sm:text-base lg:mt-6 lg:max-w-xl lg:text-left lg:text-lg" data-id="element-114" data-mp="naa0oqsklilz">
              The complete tennis coaching bible — 12 volumes, 6 strategic bonuses, 150+ drills,
              planning tools and more.{' '}
              <span className="font-semibold text-white" data-id="element-115" data-mp="1b1ffd2mry4up">Everything already done for you.</span>
            </p>

            <ul className="mt-3 flex flex-wrap justify-center gap-x-3 gap-y-1.5 lg:mt-8 lg:justify-start lg:gap-x-5 lg:gap-y-3" data-id="element-116" data-mp="161j7utevbvae">
              {features.map(feature => <li key={feature} className="flex items-center gap-1.5 text-[11px] font-medium sm:text-sm" data-id="element-117" data-mp="x1edpkyoqte6">
                  <CheckIcon className="h-3.5 w-3.5 text-ball sm:h-4 sm:w-4" strokeWidth={3} aria-hidden="true" data-id="element-118" data-mp="3lu9tcq3qfe5y" />
                  {feature}
                </li>)}
            </ul>

            <div className="mt-4 lg:mt-10" data-id="element-119" data-mp="21bplrecubp0o">
              <CtaButton size="hero" className="w-full sm:w-auto" data-id="element-120" data-mp="218jzs7zid396">
                🚀 Get Tennis 360 Now — Only $27
              </CtaButton>
              <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[10px] text-court-600 sm:text-xs lg:mt-4 lg:justify-start lg:gap-x-5 lg:gap-y-2" data-id="element-121" data-mp="2b1rb09gxjdh6">
                <span className="flex items-center gap-1.5" data-id="element-122" data-mp="2kydtirls9sg1">
                  <LockIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-123" data-mp="2l100oq4ri5xq" /> Secure
                  Payment
                </span>
                <span className="flex items-center gap-1.5" data-id="element-124" data-mp="2tztu67msqg72">
                  <ZapIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-125" data-mp="2tx7okdjguarh" /> Instant
                  Access
                </span>
                <span className="flex items-center gap-1.5" data-id="element-126" data-mp="zkra4pginqbj">
                  <ShieldCheckIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-127" data-mp="zndob7xwx42q" /> 7-Day
                  Guarantee
                </span>
              </p>
            </div>
          </div>

          <div className="hidden lg:block" data-id="element-128" data-mp="3vk1mu93dsl2i">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} width={928} height={1160} decoding="async" fetchPriority="high" className="mx-auto h-auto w-full max-w-lg object-contain" data-id="element-129" data-mp="e8io1u2wevca" />
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl bg-court-800 sm:grid-cols-4 lg:mt-14" data-id="element-130" data-mp="3csqxhwdb0gcq">
          {stats.map(stat => <div key={stat.label} className="bg-court-950 px-4 py-5 text-center" data-id="element-131" data-mp="3motxavkoo2wi">
              <p className="font-display text-2xl font-black text-ball" data-id="element-132" data-mp="2yzsupoyj7lz5">{stat.value}</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-court-600" data-id="element-133" data-mp="2yxg5qrucwbcl">
                {stat.label}
              </p>
            </div>)}
          <div className="bg-court-950 px-4 py-5 text-center" data-id="element-134" data-mp="19h2q0hilpi4e">
            <p className="flex items-center justify-center gap-1.5 font-display text-2xl font-black text-ball" data-id="element-135" data-mp="1e9vvx8pt2wi2">
              <GlobeIcon className="h-5 w-5" aria-hidden="true" data-id="element-136" data-mp="zlivnzjoqrhr" />
            </p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-court-600" data-id="element-137" data-mp="14j15rt9fvcrc">Worldwide</p>
          </div>
        </div>

        <div className="mt-4 grid gap-4 md:grid-cols-3 lg:mt-10" data-id="element-138" data-mp="1sagdy2nwcoai">
          {heroTestimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-court-800 bg-court-900 p-6" data-id="element-139" data-mp="1x7gig953lizi">
              <p className="text-sm tracking-[0.1em] text-ball" aria-label="5 out of 5 stars" data-id="element-140" data-mp="1n90toctjmlt6">
                ⭐⭐⭐⭐⭐
              </p>
              <blockquote className="mt-4 text-sm leading-relaxed text-white" data-id="element-141" data-mp="7veee9r82kkr">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5 text-xs text-court-600" data-id="element-142" data-mp="2ei3qk7xqedgn">
                <span className="font-semibold text-white" data-id="element-143" data-mp="29ih91maveb21">{testimonial.name}</span> ·{' '}
                {testimonial.role} · {testimonial.location}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </header>;
}